<template>
  <header :class="['header', 'panel', _isMobile() ? 'mobile' : '']">
    <div class="logo-bar">
      <a-row type="flex" justify="space-between" class="menu-up">
        <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <div class="logo">
              <!-- <router-link to="/"> -->
              <img :src="logo ? logo : '/img/logo.png'" alt=""/>
              <!-- </router-link> -->
              <h2>{{brandName}}</h2>
          </div>
        </a-col>
        <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <div class="login-btn-wrap">
            <a-input-search
              placeholder="全站搜索"
              style="width: 200px;"
              @search="onSearch"
            />
            <a-divider type="vertical" />
            <!-- <router-link
              class="help"
              :to="{ path: '/cms/preview', query: { category: 8 } }"
            >
              帮助
            </router-link>
            <a-divider type="vertical" /> -->
            <a-avatar @click="toCenter" icon="user" :src="avatarUrl" />
            <span v-if="$store.state.user.info">
              <span @click="toCenter">{{ $store.state.user.info.realname }}</span>
              <a-divider type="vertical" />
              <span @click="handleLogout">退出</span>
            </span>
            <span v-else>
              <span @click="toLogin">登录</span>
              <a-divider type="vertical" />
              <span @click="toRegister">注册</span>
            </span>
          </div>
        </a-col>
      </a-row>
    </div>
    <div
      :class="['menu-bar', showMenu ? 'show' : 'hide', menuFixed?'menu-fixed':'']"
      @mouseleave="leave"
      @mouseover="over"
    >
      <t-menu class="menu" mode="horizontal" :menu="menus"></t-menu>
    </div>
  </header>
</template>
<script>
import Vue from "vue";
import { TENANT_CONFIG, ACCESS_TOKEN } from "@/store/mutation-types";
import config from "../theme.config";
import { mapActions } from "vuex";
import { mixinDevice } from "@/utils/mixin.js";
import TMenu from "@/components/menu"
import { jumpMixins } from "@/utils/jumpMixins"
import { getQiniuUrl,getQiniuFile } from '@/utils/qiniu.js'

export default {
  name: "Header",
  mixins: [mixinDevice, jumpMixins],
  props: {
    autoHide: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    TMenu
  },
  data() {
    return {
      showLogin: false,
      showRegister: false,
      showMenu: true,
      logo: "",
      token: "",
      cycssToken: "",
      menus: [],
      menuFixed: false,
      brandName: ''
    };
  },
  created() {
    this.token = Vue.ls.get(ACCESS_TOKEN);
    this.cycssToken = Vue.ls.get("cysccToken")
    let tenantInfo = this.$store.getters.tenantInfo
    this.logo = tenantInfo.logo
    this.brandName = tenantInfo.brandName
    this.menus = this.$store.getters.menuList
  },
  computed:{
    avatarUrl(){
      if(this.$store.state.user.info && this.$store.state.user.info.avatar){
        if(this.$store.state.user.info.thirdType == "cyscc"){
          return "https://cast-files.oss-cn-beijing.aliyuncs.com/" + this.$store.state.user.info.avatar
        }else{
          return this.getQiniuUrl(this.$store.state.user.info.avatar)
        }
      }else{
        return "/img/avatar.png"
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    getQiniuUrl,
    getQiniuFile,
    ...mapActions(["Logout"]),
    onSearch(v) {
      console.log(v);
      if(v != ''){
        window.open('/cms/list?kw='+v)
      }
    },
    leave() {
      if (this.autoHide) this.showMenu = false;
    },
    over() {
      if (this.autoHide) this.showMenu = true;
    },
    handleScroll(){
      let scrollTop = document.documentElement.scrollTop
      if (scrollTop >= 105) {
        this.menuFixed = true
      } else {
        this.menuFixed = false
      }
    },
    loginSuccess() {
      this.showLogin = false;
      this.userInfo = this.$store.state.user.info;
    },
    regSuccess() {
      this.showRegister = false;
      this.showLogin = true;
    },
    handleLogout() {
      const that = this;
      this.$confirm({
        title: "提示",
        content: "真的要注销登录吗 ?",
        onOk() {
          return that
            .Logout({})
            .then(() => {
              Vue.ls.remove("cysccToken")
              window.location.reload()
            })
            .catch((err) => {
              that.$message.error({
                title: "错误",
                description: err.message,
              });
            });
        },
        onCancel() {},
      });
    },
  },
};
</script>
<style lang="less" scoped>
.hide {
  height: 50px;
  background-color: transparent !important;
  transition: all 0.1s ease;
}

.logo-bar {
  z-index: 99;
  // background: #fff;
  // border-bottom: 1px solid #f5f7fa;
  .menu-up {
    max-width: 1200px;
    margin: auto;
    padding: 10px 0;
    .logo {
      margin-top: 5px;
      img {
        display: inline;
        height: 50px;
        // background: white;
        // box-shadow: white 0 0 0 5px;
      }
      h2 {
        display: inline;
        font-size: 1.5rem;
        font-family: "Noto Sans SC";
        font-weight: bold;
        color: #ffffff;
        line-height: 2rem;
        margin-left: 10px;
        vertical-align: middle;
        // text-shadow: #b3b0b0ab 5px 3px 5px;
      }
    }
    .login-btn-wrap {
      cursor: pointer;
      text-align: right;
      margin-top: 25px;
      // margin-right: 50px;
      /deep/.ant-input{
        background-color: transparent;
        color: white;
      }
      /deep/.ant-input-suffix{
        i{
          color: rgba(255, 255, 255, 0.82);
        }
      }
      .ant-avatar {
        margin-right: 5px;
      }
      span {
        color: #fff;
      }
      .help {
        color: gray;
      }
    }
  }
}
.menu-fixed{
    position: fixed;
    top: 0px;
    z-index: 99;
    background: radial-gradient(ellipse at top left, #18239f 10%, #18239f 67%);
    // /deep/.ant-menu-item > a, /deep/.ant-menu-submenu a {
    //   text-shadow:none;
    //   color: black!important;
    // }
}
.menu-bar {
  //height: 35px;
  width: 100%;
  //height: 40px;
  // transition: all 0.1s ease;
  //background-color: var(--primary-color);
  z-index: 999;
  // background-color: #fff;
  // box-shadow: #c5c0c0 0px 1px 3px;
  .menu {
    //height: 40px;
    //line-height: 40px;
    background: transparent;
    //border-bottom: unset;
    max-width: 1200px;
    margin: auto;
    .ant-menu-submenu,
    /deep/.ant-menu-item > a, /deep/.ant-menu-submenu-title > a {
      font-family: "微软雅黑 Bold", "微软雅黑 Regular", "微软雅黑", sans-serif;
      font-weight: 600;
      font-size: 16px;
      color: white;
      // text-shadow: black 0 0 5px;
    }
    .ant-menu-submenu-active,
    .ant-menu-item-active {
      background: rgba(0, 0, 0, 0.2);
      border-radius: 15px;
      border-bottom: none !important;
    }
  }
  .ant-menu-horizontal {
    border-bottom:none;
    //line-height: 35px;
  }
}

.mobile {
  .logo {
    margin-top: 5px;
    margin-left: 15px;
  }
  .login-btn-wrap {
    margin-right: 20px !important;
  }
  .ant-menu-item {
    padding: 0 8px;
  }
  .ant-menu-item > a {
    font-size: 12px !important;
  }
  .menu {
    padding: 0px 15px;
  }
}
</style>